import React, { Component } from 'react'
import { BACKEND_URL } from '../config/constants';
import LogoCliente from './HeaderLogos';

class InsightcareHeader extends Component {
  render() {
    const textIcon = (this.props.theme === 'dark' ? '_dark' : '');
    return (
      <div className={'headerStyled ' + this.props.theme}> 
        <div className={'col-sm-10 text-left ' + this.props.theme}>
          <h1 className={this.props.theme}>{this.props.title}</h1>
        </div>
        <div className='verticleLine'></div>
        <img src="/img/insightcare_lamp.svg" alt="InsightCare"/>
        <img src={"/img/powered_insightcare"+textIcon+".svg"} alt="Insightcare"  style={{height:'2vw'}}/>
        <LogoCliente backendUrl={BACKEND_URL} style={{ marginLeft: '32px' }} />
      </div>
    )
  }
}

export default InsightcareHeader;
